export interface SmsActivityCreateRequestModel {
  name: string;
  smsFrom: string;
  smsContent: string;
}
